/**
 * Maps a numeric value from one linear range to another.
 * Values outside the input range will be **extrapolated** (no clamping).
 *
 * @param value - The input value to map.
 * @param inputRangeStart - Lower bound (start) of the input range.
 * @param inputRangeEnd - Upper bound (end) of the input range.
 * @param outputRangeStart - Lower bound (start) of the output range.
 * @param outputRangeEnd - Upper bound (end) of the output range.
 *
 * @returns The mapped value in the output range.
 *
 * @example
 * mapValueToRange(5, 0, 10, 0, 100); // 50
 *
 * @example
 * // Extrapolation (no clamping)
 * mapValueToRange(15, 0, 10, 0, 100); // 150
 *
 * @remarks
 * If `inputRangeStart === inputRangeEnd`, the division by zero will yield `Infinity`/`-Infinity`
 * (or `NaN` if other terms also collapse). Callers should ensure the input and output ranges have a non-zero length.
 */
export function mapValueToRange(value, inputRangeStart, inputRangeEnd, outputRangeStart, outputRangeEnd) {
    return (outputRangeStart +
        (outputRangeEnd - outputRangeStart) *
            ((value - inputRangeStart) / (inputRangeEnd - inputRangeStart)));
}
